import React, { useContext, useEffect, useRef, useState } from 'react'
import { Link } from 'gatsby'
import { UserContext } from '../layouts/UserContext'
import PlanCards from '../pricing-new/PlanCards'
import './home-plan.scss'

// Written out in full so purgecss keeps these classes in the production build
const REVEAL_CLASSES = {
    idle: '',
    waiting: 'home-plan-waiting',
    visible: 'home-plan-visible',
}

const Pricing = () => {
    const location = useContext(UserContext)
    const currency = location === 'CA' ? 'CAD' : 'USD'
    const sectionRef = useRef(null)
    const [revealState, setRevealState] = useState('idle')

    useEffect(() => {
        const section = sectionRef.current
        const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches
        if (!section || prefersReducedMotion || !('IntersectionObserver' in window)) return

        setRevealState('waiting')
        const observer = new IntersectionObserver(([entry]) => {
            if (!entry.isIntersecting) return
            setRevealState('visible')
            observer.disconnect() // only animate the first time
        }, { threshold: 0.2 })

        observer.observe(section)
        return () => observer.disconnect()
    }, [])

    return (
        <section ref={sectionRef} className={`home-plan-container ${REVEAL_CLASSES[revealState]}`} aria-labelledby="home-plan-title">
            <div className="container">
                <div className="home-plan-content-container">
                    <div className="home-plan-header-container">
                        <div className="home-plan-text-container">
                            <h2 id="home-plan-title" className="home-plan-header-text">Meeting your organization where you’re at</h2>
                            <p className="home-plan-body-text">Starting from scratch or managing safety across multiple sites? There’s a plan built for where your organization is right now</p>
                        </div>
                        <div className="plan-compare-container">
                            <Link to="/pricing/#compare-features" className="plan-compare-link">
                                See what’s in each plan
                                <img src="/app-icons/alt-arrow-down.svg" alt="" className="plan-compare-icon plan-compare-icon-right" />
                            </Link>
                        </div>
                    </div>
                    <PlanCards currency={currency} />
                </div>
            </div>
        </section>
    )
}

export default Pricing